import { render } from "./PollsPage.vue?vue&type=template&id=2be334e4&scoped=true"
import script from "./PollsPage.vue?vue&type=script&lang=js"
export * from "./PollsPage.vue?vue&type=script&lang=js"

import "./PollsPage.vue?vue&type=style&index=0&id=2be334e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be334e4"]])

export default __exports__